export const TECHNICAL_ERROR = 'TECHNICAL_ERROR';
export const SERVER_ERROR = 'SERVER_ERROR';
export const NO_ERROR_INFO = 'No error info provided';
export const AUTH_ERROR = 'AUTH_ERROR';
export const NON_AUTHORIZED_ERROR =
	'Non-authorized request, redirecting to auth page.';
